import React, { useEffect, useState } from "react";
import { getApiAction, getSiteId, postApiAction } from "../../Utils/helper";
import Header from "../Layouts/Header";
import { useNavigate, Link } from "react-router-dom";
import CartItems from "./CartItems";
import Loader from "../Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import CancelCart from "./CancelCart";
import { BASE_URL } from '../../constants';

const Cart = () => {
  const [responseData, setResponseData] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();
  const productCartCount = useSelector((state) => state.main.productCartCount);

  const dispatch = useDispatch();
  const cartCountDetect = useSelector((state) => state.main.cartCount);
  const [showCancelPopup, setShowCancelPopup] = useState(false);

  useEffect(() => {
      const fetchData = async () => {
        try {
          let response = await getApiAction("cart", {}, 0, dispatch);
          setResponseData(response.carts);
          const totalPrice = response?.carts.reduce(
            (total, item) => total + item.sub_total,
            0
          );
          setTotalPrice(totalPrice);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
      return async () => {
        setTimeout(async () => {
          if(localStorage.getItem('booking_reference_id') !== null){
            let cartCountData = await getApiAction('cart/count', {}, 0, dispatch);
            setCartCount(cartCountData?.count)
          }
        }, 300);
  
      }
  }, [cartCountDetect]);

  const bannerStyle = {
    backgroundImage: `url(${BASE_URL}/assets/images/menu_Bg2.png)`,
  };

  const submitOrder = async () => {
    let resp = await postApiAction("order/submit", {}, 0, dispatch);
    if (resp?.order_id) {
      navigate("/"+ getSiteId() +"/checkout");
    }
  };

  const cancelOrder = async () => {
    setShowCancelPopup(true);
  };

  const closePopup = () => {
    setShowCancelPopup(false);
  }
  let tableInfo = JSON.parse(localStorage.getItem('bookingData'));

  return (
    <div>
      {showCancelPopup && <CancelCart closePopup={closePopup}/>}
      
      <div className="wrapper">
        {/* <!-- START category_wrapper --> */}
        <div className="category_wrapper" style={bannerStyle}>
          <Header />

          {/* <!-- START category_ContentArea --> */}
          <div className="category_ContentArea myOrderArea">
            <div className="container">
              <div className="subText d-flex justify-content-between align-items-center flex-wrap">
                <h2>Mi orden</h2>
                
                <Link to={`/${getSiteId()}/category-menu`} className="btn someAddBtn">
                Agregar <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M38 26H26V38H22V26H10V22H22V10H26V22H38V26Z" fill="white"></path></svg>
                </Link>
              </div>
              <div className="subHeading d-flex justify-content-between align-items-center flex-wrap">
                <h3><span style={{textTransform: 'capitalize'}}>{JSON.parse((localStorage.getItem('bookingData'))).name}</span></h3>
                <h4>No. de mesa: {tableInfo?.table_no}</h4>
              </div>
              {responseData?.map((item) => (
                <CartItems item={item} />
              ))}
              <div className="orderContent">
                <div className="text">
                  <span className="orderBg">
                    <img src={`${BASE_URL}/assets/images/orderBg1.png`} alt="" />
                    <strong className="number">{cartCount}</strong>
                  </span>
                  <p>
                    Total:{" "}
                    <span className="value">
                      ${((Math.round(totalPrice * 100) / 100).toFixed(2)).split(".")[0]}
                      <sup>{((Math.round(totalPrice * 100) / 100).toFixed(2)).split(".")[1]}</sup>
                    </span>
                  </p>

                </div>
                <div className="subText">
                  <h3>¡Tu orden aún no se encuentra cerrada! </h3>
                  <p>
                    <span>
                      Cuando te encuentres en la mesa, podrás seguir ordenando
                      más platillos a tu orden.
                    </span>{" "}
                    Una vez concluida tu experiencia, el anfitrión te hará el
                    cobro total en la comodidad de tu mesa.
                  </p>
                </div>
              </div>
            </div>

            <div className="footerSite footerBottomFixeSite">
              <div className="container">
                <div className="botton_group mt-0 d-flex flex-wrap justify-content-between">
                  <button  className="btn cancelBtn" onClick={cancelOrder}>
                    Cancelar orden
                  </button>
                  <button  className="btn ConfirmBtn" onClick={submitOrder}>
                    Confirmar orden
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- END category_ContentArea --> */}
        </div>
        {/* <!-- END category_wrapper --> */}
      </div>
    </div>
  );
};

export default Cart;
